import Decimal from 'decimal.js'

export interface BandBounds {
  upper: string
  lower: string
}

// Reproduces the contract's §7 widening formula: the band widens by one multiple of the
// configured percentages per slice (slice 0 uses 1x, slice 1 uses 2x, ...). Renders as a
// static "Allowed band: X - Y" — deliberately not a "distance to re-entry," which would
// need a live market price this feature does not subscribe to.
export function resolveBandBounds(
  arrivalPrice: string,
  upperBoundPct: string,
  lowerBoundPct: string,
  sliceIndex: number
): BandBounds {
  const arrival = new Decimal(arrivalPrice || '0')
  const multiple = sliceIndex + 1
  const upper = arrival.times(
    new Decimal(1).plus(new Decimal(upperBoundPct || '0').times(multiple))
  )
  const lower = arrival.times(
    new Decimal(1).minus(new Decimal(lowerBoundPct || '0').times(multiple))
  )
  return { upper: upper.toString(), lower: lower.toString() }
}
